import { useQuery } from "@tanstack/react-query";
import { ApiGetUserInfo } from "@/api";
import { useUserStore } from "@/store/useUserStore";
import { getToken } from "@/lib/auth";

export const useGetUserInfo = () => {
  const { setUserInfo } = useUserStore();
  return useQuery({
    queryKey: ["getUserInfo"],
    queryFn: async () => {
      const res = await ApiGetUserInfo();
      if (res.data) {
        setUserInfo(res.data);
      }
      return res.data;
    },
    refetchInterval: 1000 * 5,
    enabled: !!getToken(),
  });
};
